import { activity } from "./activity.ts";
import { auth } from "./auth.ts";
import { checkout } from "./checkout.ts";
import { common } from "./common.ts";
import { deposits } from "./deposits.ts";
import { developers } from "./developers.ts";
import { overview } from "./overview.ts";
import { payouts } from "./payouts.ts";
import { roles } from "./roles.ts";
import { security } from "./security.ts";
import { settings } from "./settings.ts";
import { shell } from "./shell.ts";
import { statement } from "./statement.ts";
import { team } from "./team.ts";
import { help } from "./help.ts";
import { tour } from "./tour.ts";
import { vault } from "./vault.ts";

/**
 * English console copy, the source every translation follows. One file per area.
 * Markup: {name} = value filled in by the code; <b>, <code>, <a> wrap words the UI styles or links.
 * Plurals are { one, other } objects. API codes (statuses, permission keys, event types) stay as keys, never translated.
 */
export const en = { common, shell, auth, overview, deposits, payouts, statement, vault, activity, developers, team, roles, settings, security, checkout, tour, help };

type Widen<T> = T extends string ? string : T extends readonly (infer U)[] ? Widen<U>[] : { [K in keyof T]: Widen<T[K]> };
/** Same shape as the English copy with every value a string, so a translation can't miss a key. */
export type Dict = Widen<typeof en>;
